
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { StorageService } from 'src/app/_services/storage.service';
import { PiiGridService } from 'src/app/_services/pii-grid.service';
import { SideNavService } from 'src/app/views/layout/sidebar/side-name.service';
import { SidebarComponent } from 'src/app/views/layout/sidebar/sidebar.component';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { environment } from 'src/environments/environment';
import { MerchantService } from '../../merchants/merchant-master/merchant.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ColDef, Column, ColumnApi, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent, GridApi, GridReadyEvent, PaginationChangedEvent, RowClickedEvent } from 'ag-grid-community';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { PiiCellRendererComponent } from 'src/app/common/pii-cell-renderer.component';

import { FormControl, FormGroup } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../customer-service';
import { UserService } from 'src/app/_services/user.service';


const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'

export interface CustomerBlockFilter {
  "columns"?: any;
  "fullname"?: string,
  "mobile"?: string,
  "startDate"?: string,
  "endDate"?: string,
  "pageRecords"?: number,
  "pageNumber"?: number,
  "emailId"?:string,
  "Status"?:string,
  "KycStatus"?: string;
}

export interface IMerchantData {
  "name": string,
  "merchantId": string,
  "businessName": string,
  "contactperson": string,
  "id": number,
  "contactno": string,
  "emailid": string,
  "state": string,
  "city": string,
  "isdeleted": string
}
const {API_URL, defaultPageSizeArr, defaultPageSize} = environment;

@Component({
  selector: 'app-customer-block',
  templateUrl: './customer-block.component.html',
  styleUrls: ['./customer-block.component.scss']
})
export class CustomerBlockComponent implements OnInit {

  @Output() merchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() merchantConfigEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() ScreeningReportEvent: EventEmitter<any> = new EventEmitter<any>();
  
  public quickFilterShow: boolean = false;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public searchMerName:string;
  public searchMID: string ;
  public resellerPartnerId:string;
  public Status:string;
  public searchFromDate: NgbDateStruct;
  public searchToDate: NgbDateStruct;
  public selectedMerchant: string;  
  public fullName : string;
  public mobileNumber : string;
  public emailId: string;
  public pageNumber : number = 0;
  totalRecords: any;
  merchantStatus: any;
  modalConfigBlocked: ModalConfig;
  modalConfigReport: ModalConfig;
  user_type:'NULL';
  tableInfo: any;
  maxSize: number;
  ellipses: boolean= true;
  private gridApi!: GridApi;
   public rowData!: IMerchantData[];
   collectiondata: number=0;
   collectionSize: number = 0;
   currentPage: number = 1;
   public permissions: any = '';
   Resultdata: any;
   resellerListOptions: any;
   merchantStatusdata: any;
   private gridColumnApi!: ColumnApi;
   currentDate:any=new Date();
   private filterObj: any = {};
   globalSearch: string = '';
   private innerWidth: number;
   modalConfigAdd: ModalConfig;
   modalConfigEdit: ModalConfig;
   modalConfigMerchant: ModalConfig;
   image : any;
   mindatadis: boolean = true;
   loading: boolean = false;
   orvreport: FormGroup;
   minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  maxDateFrom: NgbDateStruct;

   public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 172,
    resizable: true,
    sortable: true,
    // suppressSizeToFit: true,
    // suppressAutoSize: true,
    filter: false,
    autoHeight: true
  };
  @ViewChild('modalReportCustomer') private modalReportComponent: ModalComponent;
  @ViewChild('modalblokedCustomer') private modalblockedComponent: ModalComponent;
  @ViewChild('filSearchMerName') private filSearchMerName: NgSelectComponent;
  @ViewChild('filSearchMID') private filSearchMID: NgSelectComponent;
  @ViewChild('filResellerPartnerId') private filResellerPartnerId: NgSelectComponent;
  @ViewChild('filStatus') private filStatus: NgSelectComponent;
  @ViewChild('filSearchToDate') private filSearchToDate: FormControl;
  @ViewChild('filSearchFromDate') private filSearchFromDate: FormControl;

  public columnDefs: ColDef[] = [
    {field: 'fullName', headerName: 'Fullname',lockVisible:true, resizable: true, cellRenderer: 'agGroupCellRenderer'},
    { field: 'mobileNumber',  headerName: 'Contact No',lockVisible:true, },
    { field: 'governmentId',  headerName: 'CINE ID',lockVisible:true, cellRenderer: PiiCellRendererComponent, width: 250, minWidth: 200 },
    { field: 'expiryDate',  headerName: 'CINE ID Expiry Date',lockVisible:true,valueFormatter: (params: any) => { 
      if(params.value != null){
       const date = new Date(params.value);
       console.log(date); 
       return date.toLocaleDateString().split('T')[0];  
      }
      return ''
      } },
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'nationality', headerName: 'Nationality', lockVisible:true,},
    { field: 'emailId', headerName: 'Email ID', lockVisible:true,},
    { field: 'screeningId', headerName: 'Screening ID', lockVisible:true,},
    { field: 'screeningProviderCode',  headerName: 'Screening Provider Code',lockVisible:true, },
    { field: 'createdOn', headerName: 'Created On',lockVisible:true, },
  { field: 'walletStatus',  headerName: 'Wallet Status',lockVisible:true, },
  { field: 'kycStatus',  headerName: 'KYC Status',lockVisible:true, },
  { field: 'currentTrack',  headerName: 'Current Track', lockVisible:true,},
  { field: 'remark', headerName: 'Remark',lockVisible:true, },
  {field: 'actions', headerName: 'Screening Report', lockVisible: true, width: 180, cellRenderer: BtnCellRenderer, cellRendererParams: [
    {
      clicked: async (event: any, param: any) => {
        this.tableInfo = param.data.userId
        this.merchantService.viewCustomerReport(this.tableInfo)
          .subscribe((data) => {
            const reader = new FileReader();
            reader.readAsDataURL(data.body);
            new Promise((resolve) => {
              reader.onloadend = function () { resolve(reader.result); }
            }).then(data => {
              this.image = data;
              this.ScreeningReportEvent.emit(data);
              return this.modalReportComponent.open();
            });
          })
      },
      buttonIconClass: 'icon-eye'
    },
    {
      clicked: async (event: any, param: any) => {
        this.tableInfo = param.data.userId
        this.merchantService.viewCustomerReport(this.tableInfo)
          .subscribe((data) => {
            const reader = new FileReader();
            reader.readAsDataURL(data.body);
            new Promise((resolve) => {
              reader.onloadend = function () { resolve(reader.result); }
            }).then(data => {
              this.image = data;
              this.downloadPdf(data, param.data.fullName);
            });
          })
      },
      buttonIconClass: 'icon-arrow-down'
    }
  ]
  },
  {
    colId: 'unmasking', field: 'unmasking', headerName: 'Unmasking', lockVisible: true, width: 120, cellRenderer: BtnCellRenderer1, cellRendererParams: [
      {
        clicked: async (event: any, param: any) => {
          this.piiGridService.unmaskRow(param.data, this.gridApi);
        },
        buttonIconClass: 'icon-frame-1',
        buttonText: '',
        buttonVisible: true,
        customImage: 'assets/images/unmask-icon.png'
      }
    ]
  },
    // {field: 're_kyc_day',tooltipField: 're_kyc_day', headerName: 'Re KYC Date',},
    // {field: 'city', tooltipField: 'city', headerName: 'City',hide: true},
    // {field: 'created_on', headerName: 'Created On Formatted',  filter: 'agDateColumnFilter', valueFormatter: dateFormatter},
    // {field: 'status', headerName: 'Status Formatted', minWidth: 120, valueFormatter: statusFormatter},
    // {field: 'actions',headerName: 'Actions', width: 180, cellRenderer: BtnCellRenderer, cellRendererParams: [
    //    {
    //       clicked: async (event: any, param: any) => {
    //         this.tableInfo = param.data.registeredMobile
    //         console.log("Row clicked :"+this.tableInfo);
    //         var mobile = this.tableInfo;
    //         console.log("Mobile :"+mobile);
            

            //   this.merchantService.customerStatusApprove(mobile)
            //   .subscribe((data) => {
            //     console.log("Response"+JSON.stringify(data));
            //     this.alertService.successAlert(JSON.stringify(data.text));
            //     window.location.reload();
            //     })
            //   }

        //     this.BlockedmerchantSelectEvent.emit(mobile);
        //     return await this.modalblockedComponent.open();
          
        //   },
        //   buttonIconClass: 'icon-settings'
        // },
        // {
        //   clicked: async (event: any, param: any) => {
        //     this.tableInfo = param.data.registeredMobile
        //     console.log("Row clicked :"+this.tableInfo);
        //     var mobile = this.tableInfo;
        //     console.log("Mobile :"+mobile);
        //     if(window.confirm("Do you want to reject this "+param.data.fullName+" customer")){
        //       //put your delete method logic here

        //       this.merchantService.customerStatusReject(mobile)
        //       .subscribe((data) => {
        //         console.log("Response"+JSON.stringify(data));
        //         this.alertService.successAlert(JSON.stringify(data.text));
        //         window.location.reload();
        //         })

        //     }

        //     // this.BlockedmerchantSelectEvent.emit(this.tableInfo);
        //     // return await this.modalblockedComponent.open();
          
        //   },
        //   buttonIconClass: 'icon-x'
        // }
    //   ]
    // }
  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  
  constructor(private menuService: MenusService,private location : Location,private alertService: AlertService, private sideNavService: SideNavService, private merchantService: MerchantService, private router: Router, private sidebarComponent: SidebarComponent, private storageService: StorageService,
  private ngbCalender: NgbCalendar, private ngbDateParserFormatter: NgbDateParserFormatter,private customerService : CustomerService,private userService : UserService, private readonly piiGridService: PiiGridService) {

    this.maxDateFrom = this.ngbCalender.getToday();
    this.maxDate = this.ngbCalender.getToday();
    this.merchantService.getBusinessType().subscribe((data) => this.merchantStatus = data)
    console.log("============>", this.tableSelectedColumn);
  }
  async ngOnInit(): Promise<void> {
    this.innerWidth = window.innerWidth;
    this.setPageSize();
    const path = this.location.prepareExternalUrl(this.location.path());
  this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions)
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    // Apply permission-based visibility for the unmasking column (same as customer-master)
    try {
      const unmaskCol = this.columnDefs.find(c => c['colId'] === 'unmasking');
      if (unmaskCol) {
        unmaskCol.hide = !(this.permissions && this.permissions !== '');
        this.columnDefsCopy = [...(this.columnDefs.filter((col) => !col?.hide))];
        this.tableSelectedColumn = [...(this.columnDefs.filter((col) => !col?.hide))];
      }
    } catch (err) {
      console.error('unmask column toggle error', err);
    }

    this.modalConfigBlocked = {
      modalTitle: "Customer Status",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.modalConfigReport = {
      modalTitle: "Customer Screening Report",
      modalSize: 'xl',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.modalConfigAdd = {
      modalTitle: "Add Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

    this.modalConfigEdit = {
      modalTitle: "Edit Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
    this.modalConfigMerchant = {
      modalTitle: "Merchant RMS Configuration",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

  }

  onSubmit(){
    console.log("Download Button");
  }

  downloadPdf(data:any,info:any) {
    //  alert("data==="+data+"  ,   Merchant======"+Merchant)
  if(data){
      const linkSource =data;
      const downloadLink = document.createElement('a');
      const fileName = info+'_Screening_Report.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.loading = false
    }else{
      this. mindatadis = false;
      this.loading = false
    }
    }

  setPageSize(){
    // this.columnDefs = this.columnDefs.map((col)=>{
    //   if(col.field == 'actions'){
    //     col.pinned = "right";
    //   }
    //   return col;
    // });
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    }else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;
      // this.columnDefs = this.columnDefs.map((col)=>{
      //   if(col.field == 'actions'){
      //     col.pinned = null;
      //   }
      //   return col;
      // });
    }
    // this.gridApi.setColumnDefs(this.columnDefs)
  }
  updateSelectedColumn(event : any) {
    if (event.target.checked) {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }


  onExportCSV() {
    debugger
    // @ts-ignore
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Customer_Blocked_List' + "_" + referenceId;

    const filter: CustomerBlockFilter = {}
    if (this.searchMerName) filter.fullname = this.searchMerName ?  this.searchMerName : "";
    if (this.searchMID||'') filter.mobile = this.searchMID||'';
    if (this.Status||"") filter.Status= this.Status||'';
    if (this.resellerPartnerId) filter.KycStatus=this.resellerPartnerId||'';
    if (this.searchFromDate) filter.startDate = this.ngbDateParserFormatter.format(this.searchFromDate);
    if (this.searchToDate) filter.endDate = this.ngbDateParserFormatter.format(this.searchToDate);
    if (this.emailId) filter.emailId = this.emailId ||'';

    console.log(this.fullName);
    console.log(this.mobileNumber);
    if(this.fullName == "" || this.fullName == undefined){
      this.fullName = "";
    }
    if(this.mobileNumber == "" || this.mobileNumber == undefined){
      this.mobileNumber = "";
    }
    if(this.emailId == "" || this.emailId == undefined){
      this.emailId = "";
    }
    return this.customerService.getCustomerBlockedList(this.fullName,this.mobileNumber,"","",this.pageSize,this.pageNumber)
      .subscribe((data:any) => {
        debugger
        const expData: any[] = [];
        console.log("Customer Data ::"+data.content);
        (data.content).forEach((curr: any) => {
          const tempRec: any = {}
          // this.tableSelectedColumn.forEach((col) => {
          //   if (col?.field) tempRec[col?.field] = curr[col?.field]
          // })
          this.tableSelectedColumn.forEach((col) => {
            debugger
            if(!(col?.field=="actions"))

            {
            if (col?.field) tempRec[col?.field] = curr[col?.field]

          }})
          expData.push(tempRec);
        })

        // this.JSONToCSVConvertor(data?.data || data?.merchants || data || [],fileName, "Report");
        this.exportAsExcelFile(expData, fileName);
      })




  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const tempRec: any = []
    var index=0;
    this.tableSelectedColumn.forEach((col) => {
      if(!( col?.field=="actions"))
      {
       tempRec[index] = col
       index++;
    }})
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      // @ts-ignore
      header: [...tempRec.map((col:any) => col.headerName)]
    });
    // const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col:any) => col.headerName)]]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  onSearchBtnClick($event: Event) {
    const filter: CustomerBlockFilter = {}
    if (this.searchMerName) filter.fullname = this.searchMerName ?  this.searchMerName : "";
    if (this.searchMID||'') filter.mobile = this.searchMID||'';
    if (this.Status||"") filter.Status= this.Status||'';
    if (this.resellerPartnerId) filter.KycStatus=this.resellerPartnerId||'';
    if(this.ngbDateParserFormatter.format(this.searchFromDate) == "0-00-00"){
      if (this.searchFromDate) filter.startDate = "";

    }else{
      if (this.searchFromDate) filter.startDate = this.ngbDateParserFormatter.format(this.searchFromDate);
    }
    if(this.ngbDateParserFormatter.format(this.searchToDate) == "0-00-00"){
      if (this.searchToDate) filter.endDate = "";

    }else{
      if (this.searchToDate) filter.endDate = this.ngbDateParserFormatter.format(this.searchToDate);
    }
    console.log(this.fullName);
    console.log(this.mobileNumber);
    if(this.fullName == "" || this.fullName == undefined){
      this.fullName = "";
    }
    if(this.mobileNumber == "" || this.mobileNumber == undefined){
      this.mobileNumber = "";
    }
    if(this.emailId == "" || this.emailId == undefined){
      this.emailId = "";
    }
    this.currentPage= 1;
    this.pageNumber = 0;
    return this.customerService.getCustomerBlockedList(this.fullName,this.mobileNumber,"","",this.pageSize,this.pageNumber)
      .subscribe((data:any) => {
        this.rowData = data.content;
        this.collectiondata = data.content;
        this.collectionSize= data.totalElements
        if(this.rowData.length <=0){
          this.alertService.errorAlertWithMessage("No records present")
          return }
      });
  }

  async onRowDoubleClicked(param: RowClickedEvent | any) {  
    console.log("Edit CLicked");
      return await this.router.navigate(['/customerEdit'], {
       
        queryParams: {
          mid: param?.data?.mobileNumber,
          date: param?.data?.createdDate,
          userId:param?.data?.userId
        }
      })
    
  }
  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    
    debugger
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    const filter: CustomerBlockFilter = {}

    if (this.searchMerName) filter.fullname = this.searchMerName ?  this.searchMerName : "";
    if (this.searchMID||'') filter.mobile = this.searchMID||'';
    if (this.Status||"") filter.Status= this.Status||'';
    if (this.resellerPartnerId) filter.KycStatus=this.resellerPartnerId||'';
    if (this.searchFromDate) filter.startDate = this.ngbDateParserFormatter.format(this.searchFromDate);
    if (this.searchToDate) filter.endDate = this.ngbDateParserFormatter.format(this.searchToDate);
    if (this.emailId) filter.emailId = this.emailId;
    this.pageNumber = (param-1);
    console.log(this.fullName);
    console.log(this.mobileNumber);
    if(this.fullName == "" || this.fullName == undefined){
      this.fullName = "";
    }
    if(this.mobileNumber == "" || this.mobileNumber == undefined){
      this.mobileNumber = "";
    }
    if(this.emailId == "" || this.emailId == undefined){
      this.emailId = "";
    }
    return this.customerService.getCustomerBlockedList(this.fullName,this.mobileNumber,"","",this.pageSize,this.pageNumber)
      .subscribe((data:any) => {
        this.rowData = data.content;
          this.collectionSize = data.totalElements
          this.collectiondata = data.content

          this.gridApi.applyTransaction({add: this.rowData});
          this.collectionSize=data.totalElements
        }
      );
  }

  onPageSizeChanges($event: Event) {
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    const filter: CustomerBlockFilter = {}
    if (this.searchMerName) filter.fullname = this.searchMerName ?  this.searchMerName : "";
    if (this.searchMID||'') filter.mobile = this.searchMID||'';
    if (this.Status||"") filter.Status= this.Status||'';
    if (this.resellerPartnerId) filter.KycStatus=this.resellerPartnerId||'';
    if (this.searchFromDate) filter.startDate = this.ngbDateParserFormatter.format(this.searchFromDate);
    if (this.searchToDate) filter.endDate = this.ngbDateParserFormatter.format(this.searchToDate);
    if (this.emailId) filter.emailId = this.emailId;
    console.log(this.fullName);
    console.log(this.mobileNumber);
    if(this.fullName == "" || this.fullName == undefined){
      this.fullName = "";
    }
    if(this.mobileNumber == "" || this.mobileNumber == undefined){
      this.mobileNumber = "";
    }
    if(this.emailId == "" || this.emailId == undefined){
      this.emailId = "";
    }
    return this.customerService.getCustomerBlockedList(this.fullName,this.mobileNumber,"","",this.pageSize,this.pageNumber)
      .subscribe((data:any) => (
        this.rowData = data.content,
        this.collectiondata = data.content,
        this.collectionSize=data.totalElements,
         this.gridApi.applyTransaction({add: this.rowData})));

  }

  onGridReady(params: GridReadyEvent<IMerchantData>) {
    this.userService.getUserProfileNew().subscribe((data) => {
      if(data.ROLEID == 273){
        this.gridColumnApi.setColumnsVisible(["actions"], false);
      }
    });
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.userService.getUserProfileNew().subscribe((data) => {
      if(data.ROLEID == 273){
        this.gridColumnApi.setColumnsVisible(["actions"], false);
      }
    });
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);

    console.log(this.fullName);
    console.log(this.mobileNumber);
    if(this.fullName == "" || this.fullName == undefined){
      this.fullName = "";
    }
    if(this.mobileNumber == "" || this.mobileNumber == undefined){
      this.mobileNumber = "";
    }
    if(this.emailId == "" || this.emailId == undefined){
      this.emailId = "";
    }
    return this.customerService.getCustomerBlockedList(this.fullName,this.mobileNumber,"","",this.pageSize,this.pageNumber)
      .subscribe((data:any) => {
        this.rowData = data.content;
       
        console.log(" this.rowData=  masterlist==="+ JSON.stringify(this.rowData))
        this.collectiondata = data.content
        this.collectionSize= data.totalElements
        this.totalRecords =  data.totalElements
      });
  }

  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow
    if (!this.quickFilterShow) {
      // this.searchToDate = '';
      // this.searchFromDate = '';
      // this.searchMID = '';
      // this.searchMerName = '';
      // this.resellerPartnerId= '',
      // this.Status= ''
      this.filSearchMerName.handleClearClick();
      this.filSearchMID.handleClearClick();
      this.filResellerPartnerId.handleClearClick();
      this.filStatus.handleClearClick();
      this.searchFromDate = this.ngbCalender.getToday();
      this.searchToDate = this.ngbCalender.getToday();
      this.refreshGrid();
    }
  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) ||(charCode >= 97 && charCode <= 122) || (charCode == 32 )) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }
  changeDate(){
    this.currentDate = this.searchFromDate
    this.minDate = this.searchFromDate;
    let mmmm = this.ngbDateParserFormatter.format(this.searchFromDate);
  }


  changeEndDate()
  {
    this.currentDate = this.searchToDate;
    this.maxDateFrom=this.searchToDate;
  }

  onFilterChange(param: FilterChangedEvent | any) {

  }

  onFilterModified(param: FilterModifiedEvent | any) {
    // console.log("onFilterModified----->",param);
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onSortChange(event : any){    
    const listOfSortModel =  this?.gridColumnApi?.getColumnState().filter(s => s.sort !== null)
    console.log("==Sort===>", listOfSortModel);
  }
  allowAlfanumeric($event: Event): void {
    if(this.searchMID.length>10)
    {
      return
    }

    this.searchMerName = this.searchMerName.replace(/[^a-z 0-9]/gi,'')||'';
    this.searchMID = this.searchMID.replace(/[^a-z 0-9]/gi,'')||'';
  }
  fun(id:any){
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id:any){
    document?.getElementById(id)?.classList.remove("hey")
  }

  refreshGrid() {
    this.gridApi.applyTransaction({remove: this.rowData});
    console.log(this.fullName);
    console.log(this.mobileNumber);
    if(this.fullName == "" || this.fullName == undefined){
      this.fullName = "";
    }
    if(this.mobileNumber == "" || this.mobileNumber == undefined){
      this.mobileNumber = "";
    }
    if(this.emailId == "" || this.emailId == undefined){
      this.emailId = "";
    }
    return this.customerService.getCustomerBlockedList(this.fullName,this.mobileNumber,"","",this.pageSize,this.pageNumber)
      .subscribe((data:any) => (
        this.rowData = data.content,
        this.collectiondata = data.content,  
        this.collectionSize=data.totalElements
        ));
  }

  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalblockedComponent.close();
      this.refreshGrid();
    }
  }

  resetFilter(){
    this.searchFromDate = {year: 0,month: 0,day: 0,};
    this.searchToDate = {year: 0,month: 0,day: 0,};
    this.searchMerName = "";
    this.searchMID = "";
    this.emailId = "";
    this.filStatus.handleClearClick();
    this.filResellerPartnerId.handleClearClick();

  }

  

}
